<div>
  <div >
    <div class="row ">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10" >
          
          <div class="row">
    <div class="col-md-10 pink">
      <i class="fa fa-id-card"></i> Resume Upload
    </div>
   
  </div>
        </div>
        <div class="card-body padding-all-0px margin-left-zero margin-top-10">
          <label *ngIf="!FirstDoc">
            To upload your resume, <a (click)="openDocContent()" class="nav-link-hand education-navlink click-label color-datacolor">click<i class="fa fa-paperclip grey color-datacolor"></i></a>

          </label>
          <label *ngIf="FirstDoc">
            You can upload your latest resume,  <a (click)="openDocContent()" class="nav-link-hand education-navlink click-label color-datacolor">click <i class="fa fa-paperclip grey color-datacolor"> </i></a>

          </label>
         

        </div>
      </div>
      
      </div>
    </div>

 
  </div>

